<form [formGroup]="phoneForm">
  <app-simple-string-value-accessor label="Telefon"
                                    formControlName="phone"
                                    required="true"></app-simple-string-value-accessor>
  <app-simple-select-value-accessor label="Status"
                                    formControlName="statusId"
                                    [data]="statuses"
                                    required="true"></app-simple-select-value-accessor>
</form>
<div class="actions">
  <button mat-raised-button
          action-button
          class="width-100"
          [disabled]="!phoneForm.valid"
          color="primary"
          type="button"
          [action]="addPhone.bind(this)">
    Dodaj telefon
  </button>
</div>
